import { styled } from "styled-components";
import ProductList from "components/organisms/ProductList";
import { BenefitProductInfoType } from "types/Benefit";
import PersonalProductList from "./PersonalProductList";
import { BenefitManualProductModel } from "models/benefitManualProductModel";

interface Props {
  mainProductsInfo: BenefitProductInfoType;
  goldProductsInfo: BenefitProductInfoType & { onTimerReached?: () => void };
  personalProductsInfo: BenefitProductInfoType;
  setActiveTab: (tab: number) => void;
  partnerProductList?: BenefitManualProductModel[];
}

const BenefitMainProductList = ({
  mainProductsInfo,
  goldProductsInfo,
  personalProductsInfo,
  setActiveTab,
  partnerProductList,
}: Props) => {
  return (
    <StyledContainer>
      {partnerProductList &&
        partnerProductList.length > 0 &&
        partnerProductList.map(
          (item) =>
            item.mainTitle &&
            item.productList && (
              <StyledProductContainer
                key={`partnerProduct_${item.categoryCd}_${item.manualId}`}
              >
                <ProductList
                  productData={item.productList}
                  title={item.mainTitle}
                  subTitle={item.subTitle ?? ""}
                  setActiveTab={setActiveTab}
                />
              </StyledProductContainer>
            ),
        )}
      {goldProductsInfo.productData &&
        goldProductsInfo.productData.length > 0 && (
          <StyledProductContainer>
            <ProductList
              productData={goldProductsInfo.productData}
              title={goldProductsInfo.title || ""}
              subTitle={goldProductsInfo.subTitle || ""}
              setActiveTab={setActiveTab}
              isTimer
              isMain
              onTimerReached={goldProductsInfo.onTimerReached}
            />
          </StyledProductContainer>
        )}
      {mainProductsInfo.productData &&
        mainProductsInfo.productData.length > 0 && (
          <StyledProductContainer>
            <ProductList
              productData={mainProductsInfo.productData}
              title={mainProductsInfo.title || ""}
              subTitle={mainProductsInfo.subTitle || ""}
              setActiveTab={setActiveTab}
            />
          </StyledProductContainer>
        )}
      {personalProductsInfo.productData &&
        personalProductsInfo.productData.length > 0 && (
          <StyledProductContainer>
            <PersonalProductList
              productData={personalProductsInfo.productData}
              title={personalProductsInfo.title || ""}
              subTitle={personalProductsInfo.subTitle || ""}
            />
          </StyledProductContainer>
        )}
    </StyledContainer>
  );
};

export default BenefitMainProductList;

const StyledContainer = styled.div`
  display: flex;
  flex-direction: column;
  padding-top: 24px;
  gap: 40px;
`;

const StyledProductContainer = styled.div``;
